/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Ui_Split_LabelInputs */

const en_ui_split_label = /** @type {(inputs: Ui_Split_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Split ${i?.number}`)
};

const de_ui_split_label = /** @type {(inputs: Ui_Split_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Split ${i?.number}`)
};

/**
* | output |
* | --- |
* | "Split {number}" |
*
* @param {Ui_Split_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_split_label = /** @type {((inputs: Ui_Split_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Split_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_split_label(inputs)
	return de_ui_split_label(inputs)
});